import React, { Dispatch, SetStateAction } from 'react';

type IExpansionContext = {
  openMap: { [uuid: string]: boolean };
  setOpenMap: Dispatch<SetStateAction<{ [uuid: string]: boolean }>>;
};

const ExpansionContext = React.createContext({} as IExpansionContext);
export default ExpansionContext;
